/* NEW: UI_REVAMP */
import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import GradientBox from '../../box/GradientBox';
import { getVoidButtonVisualState } from './voidButtonUtils';
import {
	RECORD_GRADIENTS,
	RECORD_SURFACES,
	RECORD_TEXT_COLORS,
} from '../../../styles/recordUiTokens';

const VoidActionButton = ({ isEnabled, onOpen }) => {
	const styles = getVoidButtonVisualState(isEnabled);

	return (
		<GradientBox
			position={{ base: 'fixed', lg: 'static' }}
			left={{ base: '0', lg: 'auto' }}
			right={{ base: '0', lg: 'auto' }}
			bottom={{ base: '0', lg: 'auto' }}
			marginTop={{ base: '0', lg: '2' }}
			width='100%'
			maxWidth={{ base: '100vw', lg: '100%' }}
			borderRadius='16px'
			flex='1'
			minH='0'
			variant='purpleWhite'
			bgGradient={RECORD_GRADIENTS.voidShellBorder}
		>
			<Box
				width='100%'
				padding='16px'
				borderRadius='16px'
				background={RECORD_SURFACES.voidShell}
				backdropFilter='blur(10px)'
				sx={{
					WebkitBackdropFilter: 'blur(10px)',
				}}
			>
				{isEnabled ? (
					<Text
						marginBottom={3}
						fontSize='14px'
						fontWeight='500'
						lineHeight='100%'
						textAlign='right'
						color='#D7212C'
					>
						Void ticket within 5mins after ticket&apos;s bet time.
					</Text>
				) : null}

				<Button
					onClick={isEnabled ? onOpen : undefined}
					width='100%'
					height='50px'
					borderRadius='999px'
					border='0.8px'
					borderColor={styles.borderColor}
					background={styles.background}
					boxShadow={styles.boxShadow}
					_hover={{
						background: styles.background,
						borderColor: styles.borderColor,
						boxShadow: styles.boxShadow,
					}}
					_active={{
						transform: isEnabled ? 'translateY(1px)' : 'none',
					}}
					_focus={{
						boxShadow: styles.boxShadow,
					}}
					_focusVisible={{
						boxShadow: styles.boxShadow,
					}}
					_disabled={{
						opacity: 1,
						cursor: 'not-allowed',
						background: styles.background,
						borderColor: styles.borderColor,
						boxShadow: styles.boxShadow,
					}}
					isDisabled={!isEnabled}
				>
					<Flex alignItems='center' justifyContent='center' gap='10px'>
						<Flex
							width='16px'
							height='16px'
							borderRadius='full'
							backgroundColor='#FFFFFF'
							alignItems='center'
							justifyContent='center'
							flexShrink={0}
						>
							<CloseIcon boxSize='8px' color={styles.iconColor} />
						</Flex>
						<Text
							color={RECORD_TEXT_COLORS.white}
							fontSize='16px'
							fontWeight='semibold'
							letterSpacing='0'
							lineHeight='100%'
						>
							Void Ticket
						</Text>
					</Flex>
				</Button>
			</Box>
		</GradientBox>
	);
};

export default VoidActionButton;
